/* tslint:disable:whitespace */
import * as React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Field, reduxForm, getFormValues } from 'redux-form'
import InputField from '@App/components/fields/InputField'
import { Button } from 'relevant-ui'
import * as jwtDecode from 'jwt-decode'
import {
  CREATE_PASSWORD_FORM_PASSWORD_LABEL,
  CREATE_PASSWORD_FORM_CONFIRM_LABEL,
  SUBMIT,
  CREATE_PASSWORD_FORM,
} from '@App/constantes/strings'
import { EMAIL } from '@App/constantes'
import { getCreatePassword } from 'actions'

import './styles.scss'

class CreatePasswordForm extends React.Component<any, any, any> {
  constructor(props: any) {
    super(props)

    this.state = {
      strongPassword: 'Inadéquate - min 8 caractères, une majuscule, une lettre et un chiffre.',
      password: '',
      slider: 2,
      email: '',
    }

    this.submitForm = this.submitForm.bind(this)
  }

  componentWillMount() {
    const {
      history: {
        location: {
          search,
        },
      },
    } = this.props

    const getToken = search.split('=')[1]

    if (getToken) {
      const decode: any = jwtDecode(getToken)

      this.setState({
        email: decode.email || '',
      })
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    const regExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/
    const { password } = this.state
    const { password: prevPassword } = prevState

    if (password !== prevPassword) {
      if (password.match(regExp)) {
        this.setState({
          slider: 90,
          color: '#72C54B',
          strongPassword: 'Adéquate - Mot de passe sécurisé',
        })
      } else {
        this.setState({
          slider: 2,
          color: '#AD0000',
          strongPassword: 'Inadéquate - min 8 caractères, une majuscule, une lettre et un chiffre',
        })
      }
    }
  }

  submitForm() {
    const {
      createPassword,
      history: {
        location: {
          search,
        },
      },
    } = this.props

    const getToken = search.split('=')[1]
    const password = this.props[CREATE_PASSWORD_FORM_PASSWORD_LABEL]

    createPassword({ password, token: getToken })
  }

  render() {
    const {
      handleSubmit,
      submitting,
      pristine,
      isResetPassword,
    } = this.props

    const {
      strongPassword,
      slider,
      color,
      email,
    } = this.state

    return (
      <div>
        <form onSubmit={handleSubmit(this.submitForm)}>
          {isResetPassword && email !== '' && (
            <Field
              component={InputField}
              name={EMAIL}
              disabled={true}
              email={email !== '' ? email : undefined}
            />
          )}
          <div className="password">
            <Field
              component={InputField}
              name={CREATE_PASSWORD_FORM_PASSWORD_LABEL}
              label={CREATE_PASSWORD_FORM_PASSWORD_LABEL}
              onChange={(pEvt: any) => this.setState({ password: pEvt.target.value })}
              primary
            />
            <div className="password__strong">
              <h2 className="password__strong__title">{strongPassword}</h2>
              <div className="password__strong__value">
                <div style={{ width: `${slider || 0}%`, backgroundColor: color }}
                  className="password__strong__value__slider"></div>
              </div>
            </div>
          </div>
          <Field
            component={InputField}
            name={CREATE_PASSWORD_FORM_CONFIRM_LABEL}
            label={CREATE_PASSWORD_FORM_CONFIRM_LABEL}
            primary
          />
          <div className="wrapperButton">
            <Button
              button="primary"
              type="submit"
              size="large"
              disabled={pristine || submitting}
              label={SUBMIT}
            />
          </div>
        </form>
      </div>
    )
  }
}

const validate = (values: any) => {
  const regExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/
  const errors = {}

  if (
    (values[CREATE_PASSWORD_FORM_PASSWORD_LABEL] && !values[CREATE_PASSWORD_FORM_PASSWORD_LABEL].match(regExp)) ||
    values[CREATE_PASSWORD_FORM_PASSWORD_LABEL] !== values[CREATE_PASSWORD_FORM_CONFIRM_LABEL]
  ) {
    errors[CREATE_PASSWORD_FORM_PASSWORD_LABEL] = 'Not yet !'
  }

  if (
    values[CREATE_PASSWORD_FORM_CONFIRM_LABEL] && !values[CREATE_PASSWORD_FORM_CONFIRM_LABEL].match(regExp) ||
    values[CREATE_PASSWORD_FORM_PASSWORD_LABEL] !== values[CREATE_PASSWORD_FORM_CONFIRM_LABEL]
  ) {
    errors[CREATE_PASSWORD_FORM_CONFIRM_LABEL] = 'Not yet !'
  }

  return errors
}

const CreatePassword = reduxForm<any, any, any>({
  validate,
  form: CREATE_PASSWORD_FORM,
  enableReinitialize: true,
})(CreatePasswordForm)

const mapStateToProps = (state: Object) => {
  const values = getFormValues(CREATE_PASSWORD_FORM)(state) || {}
  return {
    ...values,
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  return {
    createPassword: ({ password, token }: any) => dispatch(getCreatePassword({ password, token })),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreatePassword))
